import styled from 'styled-components'

function RadioObjective({ state, setState, disabled = false, options }) {
    return (
        <RadioGroup>
            {options.map((option, key) => (
                <CustomRadio
                    key={key}
                    onClick={() =>
                        !disabled &&
                        (state === options[key]
                            ? setState('')
                            : setState(options[key]))
                    }
                    active={state === options[key]}
                >
                    {option}
                </CustomRadio>
            ))}
        </RadioGroup>
    )
}

const RadioGroup = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    max-width: 350px;
    margin: 10px auto;
`
const CustomRadio = styled.div`
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    height: 35px;
    width: 35px;
    border: 2px solid #fff;
    text-transform: uppercase;
    transition: all ease-in-out 0.15s;
    font-size: 16px;
    color: ${({ active }) => (active ? `#2E2E53` : `#fff`)};
    background: ${({ active }) => (active ? `#fff` : `#2E2E53`)};
`

export default RadioObjective
